import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { createChecklistGrupo } from "../../api/editChecklistApi";

type FormValues = {
  descricao_checklist_grupo: string;
  ajuda_checklist_grupo?: string | null;
  imagem_checklist_grupo?: string | null;
  rodape_checklist_grupo?: string | null;
  ordem_checklist_grupo?: number;
};

const NovoGrupo: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const checklistId = Number(id);
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      descricao_checklist_grupo: "",
      ajuda_checklist_grupo: "",
      imagem_checklist_grupo: "",
      rodape_checklist_grupo: "",
      ordem_checklist_grupo: undefined,
    },
  });

  const onSubmit = async (form: FormValues) => {
    try {
      setSaving(true);
      const token = localStorage.getItem("token") || "";

      await createChecklistGrupo(token, {
        descricao_checklist_grupo: form.descricao_checklist_grupo,
        ajuda_checklist_grupo: form.ajuda_checklist_grupo,
        imagem_checklist_grupo: form.imagem_checklist_grupo,
        rodape_checklist_grupo: form.rodape_checklist_grupo,
        ordem_checklist_grupo: form.ordem_checklist_grupo,
        id_checklist: checklistId,
      });

      toast.success("Grupo criado com sucesso!");
      navigate(`/checklist/${checklistId}/grupos`);
    } catch (err) {
      console.error(err);
      toast.error("Erro ao criar grupo");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 900 }}>
      <Typography variant="h5" mb={2}>
        Adicionar novo grupo de perguntas (Checklist #{checklistId})
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="descricao_checklist_grupo"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Descrição do Grupo"
              fullWidth
              margin="normal"
              required
            />
          )}
        />

        <Controller
          name="ajuda_checklist_grupo"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ajuda do Grupo"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Controller
          name="imagem_checklist_grupo"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Imagem (URL/base64)"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Controller
          name="rodape_checklist_grupo"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Rodapé do Grupo"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Controller
          name="ordem_checklist_grupo"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              type="number"
              label="Ordem"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Box mt={2} display="flex" gap={2}>
          <Button variant="contained" type="submit" disabled={saving}>
            {saving ? <CircularProgress size={24} /> : "Salvar Grupo"}
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(`/checklist/${checklistId}/grupos`)}
          >
            Voltar
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default NovoGrupo;
